<template>
  <div><div :style="styles" :class="classess" /></div>
</template>
<script>
export default {
  props: ['state'],
  data() {
    return {
      style: null,
      classes: null,
      poleState: this.state,
    };
  },
  computed: {
    styles() {
      return this.borderType();
    },
    classess() {
      return this.classNames({
        Circle: true,
        Available: this.poleState.className === 'Available',
        Reserved: this.poleState.className === 'Reserved',
        Charging: this.poleState.className === 'Charging',
        Unavailable: this.poleState.className === 'Unavailable',
        TestActive: this.poleState.active,
      });
    },
  },
  methods: {
    borderType() {
      if (this.poleState.type === 'dashed') {
        return { '--chip-border-type': 'dashed' };
      }
      return { '--chip-border-type': 'solid' };
    },
    classNames(obj) {
      return Object.entries(obj)
        .filter(([, bool]) => bool)
        .map(([key]) => key)
        .join(' ');
    },
  },
};
</script>
<style scoped>
.Circle {
  --circle-size: 20px;
  --circle-border-width: 1px;
  width: var(--circle-size);
  height: var(--circle-size);
  border-radius: 50%;
  border-width: var(--circle-border-width);
  border-style: var(--chip-border-type, solid);
  display: none;
}
.Available .Circle {
  border-color: #7dcc93;
}
.Reserved .Circle {
  border-color: #ffdf22;
}
.Charging .Circle {
  border-color: #2299ff;
}
.Unavailable .Circle {
  border-color: #f15c5e;
}

.Active .Circle {
  border-color: var(--chip-border-color);
}

@media (min-width: 768px) {
  .Circle {
    display: block;
    --circle-size: 15px;
    --circle-border-width: 1px;
  }
}
@media (min-width: 1200px) {
  .Circle {
    --circle-size: 15px;
  }
}
@media (min-width: 1280px) {
  .Circle {
    --circle-size: 15px;
  }
}
@media (min-width: 1400px) {
  .Circle {
    --circle-size: 25px;
    --circle-border-width: 2px;
  }
}
</style>
